


















import Vue, {PropType} from 'vue'
import {Column} from "@/components/table/types";
import FieldInput from "@/components/form/FieldInput.vue";

export default Vue.extend({
    name: 'ColumnsTable',
    props: {
        columns: {
            type: Array as PropType<Array<Column>>
        },
    },
    components: {
        FieldInput
    },
    computed: {},
    methods: {
        modalClose() {
            this.modal = false
        },
        columnIsSelected(column: Column) {
            return !!column.visible || column.visible == undefined
        },
        selectColumn(column: Column) {
            this.$emit('change', {
                name: column.name,
                visible: !(column.visible === undefined || column.visible === true)
            })
        },
    },
    data: function () {
        return {
            modal: false as boolean,
        }
    }
})
